import React from "react";
import classNames from "classnames/bind";

import styles from "./MainPageProduct.module.scss";
import PopUpTooltip from "../../../../../components/UI/PopoverTooltip";
import { Product, ProductType } from "@core/types";
import { useCreatePriceMarkup } from "../../../../../utils/useCreatePriceMarkup";

interface ProductPriceProps {
  product: Product;
}

const cx = classNames.bind(styles);

export const ProductPrice = ({ product }: ProductPriceProps) => {
  const priceHtml = useCreatePriceMarkup(product);

  return (
    <div className={cx(product.discountPrice && "flex items-center gap-4")}>
      {(product.stockQuantity > 0 || product.type === ProductType.VARIABLE) &&
        (product.discountPrice === null ? (
          <p
            className={cx("price ellipsis", styles.price, styles.price__general, "cardIrskomContentPrice")}
            dangerouslySetInnerHTML={priceHtml}
          ></p>
        ) : (
          <>
            <div className="flex flex-col">
              <div className="flex items-center gap-1">
                <div className="text-xs font-bold">По карте</div>

                <PopUpTooltip
                  text="Цена для зарегистрированных пользователей"
                  btnStyles="inline-block rounded-full bg-slate-200 w-4 h-4 text-xs"
                  panelStyles="bottom-4 -right-12 text-xs p-2 bg-white text-black rounded border-1"
                />
              </div>
              <p
                className={cx(
                  "price ellipsis",
                  styles.price,
                  styles.price__general,
                  "cardIrskomContentPrice",
                  product.discountPrice ? "irskomDiscountPrice" : ""
                )}
                dangerouslySetInnerHTML={priceHtml}
              ></p>
            </div>
            {product.discountPrice && (
              <div className="flex colum flex-col">
                <div className="font-bold text-xs">Без карты</div>
                <div className="text-sm font-bold">{`${Number(product.discountPrice).toLocaleString("ru-RU")} ₽`}</div>
              </div>
            )}
          </>
        ))}
    </div>
  );
};
